import styled from 'styled-components';
import { COLORS, device } from '../../constants';

const CircleImage = styled.div`
  width: 80px;
  height: 80px;
  background-color: ${COLORS.BG_CIRCLE};
  border-radius: 50%;
`;

const SectionContainer = styled.div<{ $color?: string }>`
  background: ${props => props.$color || COLORS.WHITE};
  position: relative;
  z-index: 2;
  overflow: hidden;
`;

const SectionTextContainer = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.$gap ? `${props.$gap}px` : '60px')};
  @media screen and (${device.md}) {
    gap: 50px;
  }
  @media screen and (${device.sm}) {
    > span {
      font-size: 22px;
      line-height: 26px;
    }
    gap: 20px;
  }
`;

export { CircleImage, SectionContainer, SectionTextContainer };
